import type { PublicEnv, PublicEnvKey } from './public-env';

declare global {
    interface Window {
        __ENV?: PublicEnv;
    }
}

/**
 * Isomorphic accessor for public runtime configuration (see public-env.ts).
 *
 * - Browser: reads `window.__ENV`, populated by the synchronous `/env.js`
 *   script in the document head before any app bundle executes.
 * - Server / edge (SSR, middleware, route handlers, Sentry configs): reads
 *   the process environment at call time via dynamic access, which Next.js
 *   does not inline at build time.
 * - Tests (vitest / playwright-ct): no `window.__ENV` → falls back to
 *   `process.env`, so stubbing env vars keeps working.
 */
export function env(key: PublicEnvKey): string | undefined {
    if (typeof window !== 'undefined' && window.__ENV) {
        return window.__ENV[key];
    }
    return typeof process !== 'undefined' ? process.env[key] : undefined;
}
